import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls to top on every route change.
 * 
 * Uses useLayoutEffect instead of useEffect to scroll BEFORE browser paint,
 * preventing the visible "scroll jump" that occurs when useEffect is used.
 * 
 * Also disables browser's automatic scroll restoration to prevent conflicts.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Disable browser's automatic scroll restoration
    // This prevents the browser from trying to restore scroll position
    // which can conflict with our manual scroll-to-top
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Scroll to top immediately (before paint)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
